// extracted by mini-css-extract-plugin
module.exports = {"up":"Trend_up__QgWFs","down":"Trend_down__AbNQH"};